import { render, staticRenderFns } from "./StrangerFaceList.vue?vue&type=template&id=105f8356&scoped=true&"
import script from "./StrangerFaceList.vue?vue&type=script&lang=js&"
export * from "./StrangerFaceList.vue?vue&type=script&lang=js&"
import style0 from "./StrangerFaceList.vue?vue&type=style&index=0&id=105f8356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f8356",
  null
  
)

export default component.exports